import { render, staticRenderFns } from "./QueryRule.vue?vue&type=template&id=0f824775&"
import script from "./QueryRule.vue?vue&type=script&lang=js&"
export * from "./QueryRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports